// based on https://github.com/mikelpmc/react-multiline-clamping/blob/master/src/lib/clamp.js
import * as React from "react";
import { useState, useEffect } from "react";

export interface BtnProps {
  toggle: () => void
}

interface Props {
  text: string;
  length: number;
  ellipsis?: string;
  className?: string;
  showMore?: React.FC<BtnProps>;
  showLess?: React.FC<BtnProps>;
}

const defaultShowMore: React.FC<BtnProps> = ({ toggle }) => (
  <button type="button" onClick={toggle}>
    More
  </button>
);

const defaultShowLess: React.FC<BtnProps> = ({ toggle }) => (
  <button type="button" onClick={toggle}>
    Less
  </button>
);

const TextEllipsis: React.FC<Props> = ({
  text, length, ellipsis = "...", className, showMore = defaultShowMore, showLess = defaultShowLess,
}) => {
  const truncatedText = text.slice(0, length);
  const shouldTruncate = truncatedText.length < text.length;
  const [truncate, setTruncate] = useState(shouldTruncate);

  useEffect(() => {
    setTruncate(true);
  }, [text]);

  const toggleTruncate = (value: boolean) => {
    setTruncate(value);
  };

  return (
    <>
      <div className={className || ""}>
        <span style={{ whiteSpace: "pre-line" }}>{truncate ? truncatedText : text}</span>
        {truncate && shouldTruncate && ellipsis}
      </div>

      {shouldTruncate && truncate && showMore({ toggle: () => toggleTruncate(false) })}
      {shouldTruncate && !truncate && showLess({ toggle: () => toggleTruncate(true) })}
    </>
  );
};

export default TextEllipsis;
